/**
 * Normalize email address to lowercase for case-insensitive matching.
 * Email addresses are case-insensitive per RFC 5321 in practice.
 * googlemail.com is an alias for gmail.com — normalize to gmail.com.
 */
export function normalizeEmail(email: string): string {
  return email
    .toLowerCase()
    .trim()
    .replace(/@googlemail\.com$/, '@gmail.com')
}
